











import Vue from 'vue'

import { WidgetSettingType } from '../../widgets/base/widget/WidgetInterface'

import { SettingsPanelCustomCustomMixin } from './SettingsPanelCustomCustomMixin'
import SettingsPanelCustomSortableCheckboxList from '../SettingsPanelCustomSortableCheckboxList.vue'

export default Vue.extend({
  mixins: [SettingsPanelCustomCustomMixin],
  components: {
    SettingsPanelCustomSortableCheckboxList
  },
  props: {
    data: {
      type: Object,
      required: true,
    }
  },
  data() {
    const sortableVehicles = {
      title: 'Fahrzeugsortierung',
      name: 'sortVehicles',
      type: WidgetSettingType.sortableCheckboxList,
      list: this.getAvailableVehicles(),
      values: []
    }

    const config = {
      sortableVehicles,
      sortedVehicles: Object.keys(this.$store.state.cluster.vehicle),
      vehicleDiff: Object.keys(this.$store.state.cluster.vehicle)
    }

    this.syncConfigProperties(config, this.data)

    return {
      config
    }
  },

  methods: {
    getAvailableVehicles() : Array<any> {
      const list: any[] = []
      const vehiclesList = Object.keys(this.$store.state.cluster.vehicle)
      const sortableList = typeof this.data.sortableVehicles !== 'undefined' ? this.data.sortableVehicles.list : []
      const isInitialized = sortableList.length > 0

      // Load cluster qualification if newly initialized
      const iteratorList = isInitialized ? sortableList : vehiclesList

      for(let elem of iteratorList) {
        const key = isInitialized ? elem.value : elem

        // Check if saved keys still exists as cluster status
        if (!vehiclesList.includes(key)) continue

        list.push({
          type: WidgetSettingType.checkbox,
          title:this.$store.state.cluster.vehicle[key].name,
          checked: elem.checked || (isInitialized ? false : true),
          value: key,
        })
      }

      return (list)
    }
  },
  mounted() {
    Vue.set(this.config.sortableVehicles, 'list', this.getAvailableVehicles())
  },
  updated() {
    const sortableVehicles = this.config.sortableVehicles
    const config = this.config

    // Update SettingsPanel config for sortableCheckboxList
    config.sortableVehicles = sortableVehicles

    // Update sorting list
    config.sortedVehicles = sortableVehicles.list.filter(
      (elem: any) => elem.checked
    ).map(
      (elem: any) => elem.value
    )

    this.$emit('update', this.config)
  }
})
